import WorkIcon from '@mui/icons-material/Work';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import GroupsIcon from '@mui/icons-material/Groups';
import DashboardIcon from '@mui/icons-material/Dashboard';

export interface LinkInfo {
  path: string;
  text: string;
  Icon?: React.ElementType;
}

const applicantPages: LinkInfo[] = [
  {
    path: '/applications',
    text: 'My Applications',
    Icon: TextSnippetIcon,
  },
  {
    path: '/jobs',
    text: 'Jobs',
    Icon: WorkIcon,
  },
];

const hrPages: LinkInfo[] = [
  {
    path: '/dashboard',
    text: 'Dashboard',
    Icon: DashboardIcon,
  },
  {
    path: '/manage-assessments',
    text: 'Assessments',
    Icon: TextSnippetIcon,
  },
  {
    path: '/manage-jobs',
    text: 'Job Postings',
    Icon: WorkIcon,
  },
];

// const applicantSettings = ['Profile', 'Logout'];
// const hrSettings = ['Logout'];
const applicantSettings = [
  {
    path: '/profile',
    text: 'Profile',
  },
  {
    path: '',
    text: 'Logout',
  },
];

const hrSettings = [
  {
    path: '',
    text: 'Logout',
  },
];

export interface NavbarDataType {
  pages: LinkInfo[];
  settings: LinkInfo[];
}

export const getNavbarData = (isHR: boolean): NavbarDataType => {
  if (isHR) {
    return {
      pages: hrPages,
      settings: hrSettings,
    };
  } else {
    return {
      pages: applicantPages,
      settings: applicantSettings,
    };
  }
};
